import { useState } from "react";
import { MenuIcon } from "../icons/icons";

export const Nav = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-20 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="text-2xl font-extrabold text-teal-600 tracking-tight">
            Stedway<span className="text-orange-600">Tech</span>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {['Services', 'Projects', 'Contact'].map((item: string) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className="text-gray-600 hover:text-teal-600 font-medium transition duration-150 ease-in-out"
              >
                {item}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <a href="#contact" className="hidden md:block bg-orange-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-orange-700 transition duration-300 shadow-md transform hover:scale-[1.02]">
            Get Started
          </a>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-600 hover:text-teal-600 focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen}
            aria-label="Toggle menu"
          >
            <MenuIcon className="w-6 h-6" />
          </button>
        </div>
      </div>
      
      {/* Mobile Menu Content */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg border-t border-gray-100 pb-4">
          <div className="flex flex-col space-y-2 px-4 sm:px-6">
            {['Services', 'Projects', 'Contact'].map((item: string) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={() => setIsOpen(false)}
                className="block text-gray-700 hover:bg-gray-50 px-3 py-2 rounded-lg font-medium transition duration-150 ease-in-out"
              >
                {item}
              </a>
            ))}
            <a 
                href="#contact" 
                onClick={() => setIsOpen(false)}
                className="block text-center bg-orange-600 text-white px-3 py-2 mt-2 rounded-lg font-semibold hover:bg-orange-700 transition duration-300"
            >
                Start a Project
            </a>
          </div>
        </div>
      )}
    </header>
  );
};